import { z } from 'zod';

export const FormSubmissionSchema = z.object({
    id: z.string().optional(),
    formId: z.string().min(1),
    data: z.record(z.any()), // Form data
    files: z.array(z.string()).optional(), // File IDs/URLs
    submittedBy: z.string().optional(),
    submittedAt: z.string().or(z.date()).optional(),
    status: z.string().default('submitted'),
    approvalStatus: z.string().default('pending'),
    vendorAssessment: z.string().optional(),
    entityType: z.string().optional(),
    entityId: z.string().optional(),
    entityLabel: z.string().optional(),
    source: z.enum(['workflow', 'vendor', 'direct', 'manual', 'scheduled', 'periodic']).optional(),
    workflowInstanceId: z.string().optional(),
    formTaskId: z.string().optional(),
    workflowTask: z.string().optional(),
    surveyDispatchId: z.string().optional(),
    totalScore: z.number().optional(),
    maxScore: z.number().optional(),
    questionScores: z.array(z.object({
        questionId: z.string(),
        score: z.number(),
        maxScore: z.number(),
    })).optional(),
    createdAt: z.date().optional(),
    updatedAt: z.date().optional(),
});

export const SubmitFormSchema = FormSubmissionSchema.pick({ formId: true, data: true, files: true }).extend({
    vendorAssessmentId: z.string().optional(),
});

export const CreateFormSubmissionSchema = FormSubmissionSchema.omit({ id: true });
export const UpdateFormSubmissionSchema = FormSubmissionSchema;
